<div class="lc-wrapper">

  <!-- Loading -->
  <div *ngIf="loading" class="lc-loading">
    <div class="lc-spinner"></div>
  </div>

  <!-- Empty -->
  <div *ngIf="!loading && lifecycleEvents.length === 0" class="lc-empty">
    <i class="ri-time-line lc-empty-icon"></i>
    <p>No activity yet</p>
  </div>

  <!-- Timeline -->
  <div *ngIf="!loading && lifecycleEvents.length > 0" class="lc-timeline">
    <div class="lc-item" *ngFor="let event of lifecycleEvents">

      <div class="lc-dot-col">
        <div class="lc-dot" [ngClass]="event.colorClass">
          <i [class]="event.iconClass"></i>
        </div>
        <div class="lc-line"></div>
      </div>

      <div class="lc-content">
        <span class="lc-label">{{ event.label }}</span>
        <span class="lc-date" *ngIf="event.user_name">{{ event.user_name }}</span>
        <span class="lc-date">{{ event.date }} &middot; {{ event.time }}</span>
      </div>

    </div>
  </div>

</div>
